import React, { useState, useEffect } from 'react';
import './message.css';
import HeadingContainer from '../heading-container/HeadingContainer';
import { Container, Box, Typography } from '@mui/material';

function Message() {
    const [messageData, setMessageData] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/messages`)
            .then(res => res.json())
            .then(data => {
                if (data && data.length > 0) {
                    setMessageData(data[0].message);
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching principal's message", err);
                setLoading(false);
            });
    }, []);

    return (
        <>
            <HeadingContainer title="Principal's Message" />
            <div className="message-wrapper">
                <Container maxWidth="md">
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                            <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
                            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                        </div>
                    ) : (
                        <Box className="message-paper hover-scale">
                            <div className="quote-mark">"</div>
                            <Typography variant="h4" className="message-title">
                                Inspiring Minds, Building Futures
                            </Typography>
                            <hr className="message-divider" />
                            <Typography variant="body1" className="message-text" style={{ whiteSpace: 'pre-line' }}>
                                {messageData || `Dear Parents and Students,\n\nIt gives me immense pleasure to welcome you to White Wings School. Education is not merely the accumulation of facts, but the preparation of life itself. At White Wings, we are committed to providing a stimulating and nurturing environment where every child's unique potential is recognized and developed.\n\nOur dedicated faculty works tirelessly to cultivate curiosity, instill strong moral values, and promote academic excellence. We believe in a holistic approach to education—one that balances rigorous scholastic demands with sports, arts, and character building.\n\nTogether, let us embark on this incredible journey of learning and growth, ensuring that our children are well-equipped to face the challenges of tomorrow with confidence and compassion.\n\n`}
                                
                                {!messageData && (
                                    <>
                                        <b>Warm Regards,</b><br />
                                        <span style={{ fontFamily: "'Dancing Script', cursive", fontSize: '1.5rem', color: 'var(--primary)', marginTop: '10px', display: 'inline-block' }}>
                                            Principal
                                        </span>
                                    </>
                                )}
                            </Typography>
                        </Box>
                    )}
                </Container>
            </div>
        </>
    );
}

export default Message;